import PropTypes from 'prop-types';
import { useCallback, useRef, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import CustomDropdownMenu from './CustomDropdownMenu';

export default function ListButton({ id, type, options, label, tooltip, onClick, onContextMenu, isDisabled }) {
  const [isPopperOpen, setPopperOpen] = useState(false);
  const optionsRef = useRef(null);

  const handleOnClick = useCallback(() => {
    setPopperOpen((current) => !current);
    onClick();
  }, [onClick]);

  return (
    <li className={`broadcast-option ${type}`} data-for={`dropdown-tooltip-${id}`} data-tip={tooltip ?? label}>
      <button
        id={`pop-over-${id}-button`}
        type="button"
        disabled={isDisabled}
        onContextMenu={onContextMenu}
        onClick={handleOnClick}
        ref={optionsRef}
        aria-label={label}
      />
      <CustomDropdownMenu
        setPopperOpen={setPopperOpen}
        isPopperOpen={isPopperOpen}
        optionsRef={optionsRef}
        popOverId={id}
        sections={options}
      />

      <ReactTooltip id={`dropdown-tooltip-${id}`} effect="solid" type="light" border />
    </li>
  );
}

const NOOP = () => ({});

ListButton.defaultProps = {
  tooltip: undefined,
  isDisabled: false,
  options: [[{ label: 'No Options Available' }]],
  onClick: NOOP,
  onContextMenu: NOOP,
};

ListButton.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['share', 'download']).isRequired,
  tooltip: PropTypes.string,
  onClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  isDisabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        onClick: PropTypes.func,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      })
    )
  ),
};
